import { Directive, HostListener, inject } from '@angular/core';
import { Params } from '@angular/router';

import { AgentLinkNavigatorService } from 'AgentApp/ts/services/agent-link-navigator.service';

const AGENT_HASH_PREFIX = '#/?';

@Directive({
    selector: '[ycnAgentLinkIntercept]',
})
export class AgentLinkInterceptDirective {
    private readonly navigator = inject(AgentLinkNavigatorService);

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent): void {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
            return;
        }

        const { target } = event;
        if (!(target instanceof Element)) {
            return;
        }

        const anchor = target.closest('a');
        if (!anchor || !anchor.href) {
            return;
        }

        let url: URL;
        try {
            url = new URL(anchor.href, window.location.origin);
        } catch {
            return;
        }

        if (url.origin !== window.location.origin) {
            return;
        }

        if (this.normalizePath(url.pathname) !== this.normalizePath(window.location.pathname)) {
            return;
        }

        if (!url.hash.startsWith(AGENT_HASH_PREFIX)) {
            return;
        }

        const paramString = url.hash.slice(AGENT_HASH_PREFIX.length);
        const params = this.parseParams(paramString);

        event.preventDefault();
        this.navigator.navigateToParams(params, anchor.href);
    }

    private normalizePath(path: string): string {
        return path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
    }

    private parseParams(paramString: string): Params {
        const searchParams = new URLSearchParams(paramString);
        const params: Params = {};
        searchParams.forEach((value, key) => {
            params[key] = value;
        });
        return params;
    }
}
